import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"phone\"><path d=\"M506 410l-112-68c-7-3-16-3-20 4l-32 32c-3 3-12 9-19 9 0 0-41 0-121-77-80-76-80-121-80-121 0-7 3-16 9-19l29-29c3-3 6-13 3-19L102 6c-3-6-9-9-16-3L10 80C6 83 0 93 0 99c0 0-16 112 141 269s269 141 269 141c6 0 16-7 19-10l77-77c9-3 6-9 0-12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/phone.svg
// module id = 187
// module chunks = 0